import _                                from 'underscore';
import { QuerySet, QuerySetKeys, Uuid } from '../../types';
import { capitalize }                   from "@src/util";

/* Merges a bunch of query sets w/ { queries, mutations, fragments }
 * Usually constructed in the ../queries directory */
export const mergeQueryTypes = ( querySets: QuerySet[], typeKey: QuerySetKeys ) => {

    return _.chain( querySets )
            .pluck( typeKey )
            .reduce( ( all, set ) => ( { ...all, ...set } ), {} )
            .value();
};

export const fragmentFieldsToArray = ( fragmentString: string ) => {

    return _.compact( fragmentString.trim().split( /(\W)(\w+)/gmi ).map( f => f.trim() ) );
};

export const fieldConditionIsFalsy = ( useFieldCondition: any ) => {

    return _.isUndefined( useFieldCondition ) ||
           _.isNull( useFieldCondition ) ||
           ( useFieldCondition === false );
}
export const getFieldWithProjectIdAccessor = ( projectId: Uuid, field: string ) => `${ projectId ? `${ field }( projectId: "${ projectId }" )` : `${ field }` }`;
export const getFieldWithProjectVersionIdAccessor = ( projectVersionId: Uuid, field: string, fieldParamsOpen = false ) => `${ projectVersionId ? `${ field }( projectVersionId: "${ projectVersionId }" ${ fieldParamsOpen ? `,` : `)` }` : `${ field }` }`;
export const getFieldWithProjectVersionWhereIdAccessor = ( projectVersionId: Uuid, field: string, fieldParamsOpen = false ) => `${ projectVersionId ? `${ field }( where: { id: { eq: "${ projectVersionId }" } } ${ fieldParamsOpen ? `,` : `)` }` : `${ field }` }`;

export const getProjectsWhereIdAccessor = ( projectId: Uuid, fieldParamsOpen = false ) => getFieldWithProjectVersionWhereIdAccessor( projectId, 'projects', fieldParamsOpen );
export const getProjectVersionsWhereIdAccessor = ( projectVersionId: Uuid, fieldParamsOpen = false ) => getFieldWithProjectVersionWhereIdAccessor( projectVersionId, 'projectVersions', fieldParamsOpen );

export const getFieldIfValue = ( useFieldCondition: any, field: string ) => `${ ( !fieldConditionIsFalsy( useFieldCondition ) || useFieldCondition === true ) ? `${ field }` : '' }`;
export const getFieldIfValueOrDefault = ( useFieldCondition: any, fieldOnValue: string, fieldFallback: string ) => `${ ( !fieldConditionIsFalsy( useFieldCondition ) || useFieldCondition === true ) ? `${ fieldOnValue }` : `${ fieldFallback }` }`;

export const getStaticVersionedField = ( field: string ) => {
    const formattedField = capitalize( field.trim(), true );
    return `static${ formattedField }`
};
export const maybeStaticVersionField = ( field: string, useFieldCondition = false, capitalizePrefix = false ) => {

    return ( !fieldConditionIsFalsy( useFieldCondition ) )
           ? capitalizePrefix
             ? capitalize( getStaticVersionedField( field ), true )
             : getStaticVersionedField( field )
           : field
};
